<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs
        main-link="welcome"
        :main="$t('dashboardVue.dashboard')"
        :title="$t('newTRSRequest.yeniTrAxtar')"
      />

      <h4 class="mb-3">
        {{ $t('newTRSRequest.yeniTrAxtar') }}
      </h4>


      <form @submit.prevent="createRequest">
        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newAUCRequest.soruDetallar') }}</h4>
            <hr>

            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newInfoRequest.soruBal') }}</label>
                  <b-form-input
                    id="new_request_title"
                    v-model="requestTitle"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>
                  <DatePicker
                    v-model="requestDeadline"
                    mode="dateTime"
                    is24hr
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    :minute-increment="15"
                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="col-md-12">
                <div class=" d-flex align-items-center">
                  <div class="checkbox checkbox-success ">
                    <b-form-checkbox
                      v-model="requestIsPrivate"
                      value="1"
                      :disabled="onlyVendors>0"
                    >
                      <div>
                        {{ $t('newAUCRequest.mllifiGizlt') }} <br> <span
                          v-if="requestIsPrivate"
                          class="text-danger"
                        >
                          {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                        </span>
                        <span
                          v-else
                          class="text-success"
                        >
                          {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                        </span>
                      </div>
                    </b-form-checkbox>
                  </div>
                </div>


                <div class=" d-flex align-items-center">
                  <div class="checkbox checkbox-success">
                    <b-form-checkbox
                      v-model="requestIsPersonalAllowed"
                      value="1"
                    >
                      {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                    </b-form-checkbox>
                  </div>
                </div>


<!--                <div class="d-flex align-items-center">-->
<!--                  <div class="checkbox checkbox-success">-->
<!--                    <b-form-checkbox-->
<!--                      v-model="onlyVerified"-->
<!--                      value="1"-->
<!--                    >-->
<!--                      {{ $t('newAUCRequest.ancaqTsdiqlnmiIrktIstifadilriCavablayaBilsin') }}-->
<!--                    </b-form-checkbox>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.lk') }}</label>
                  <b-form-input
                    v-model="orderExtras.pickUpCountry"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.hr') }}</label>
                  <b-form-input
                    v-model="orderExtras.pickUpCity"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('nvanIstiqamt') }}</label>
                  <b-form-input
                    v-model="orderExtras.pickUpAddress"
                    type="text"
                  />
                </div>
              </div>


              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newTRSRequest.yknXacaTarix') }}</label>
                  <DatePicker 
                    v-model="orderExtras.deadline"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    mode="date"
                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4>
              {{ $t('newLogisticRequest.sonMntq') }}
            </h4>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <div class=" mb-3">
                  <label>{{ $t('newLogisticRequest.lk') }}</label>
                  <b-form-input
                    v-model="orderExtras.dropOffCountry"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class=" mb-3">
                  <label>{{ $t('newLogisticRequest.hr') }}</label>
                  <b-form-input
                    v-model="orderExtras.dropOffCity"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class=" mb-3">
                  <label>{{ $t('nvanIstiqamt') }}</label>
                  <b-form-input
                    v-model="orderExtras.dropOffAddress"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>


        <p class="alert alert-primary my-4">
          {{ $t('newLogisticRequest.nvbtiMrhldSizDanacaqYklrlBalMlumatDolduracaqsnz') }}
        </p>


        <button class="btn btn-primary my-3">
          {{ $t('newTRSRequest.nvbtiMrhl') }}
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {createRequest, getVendorManagementStatus} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Datepicker from 'vuejs-datepicker';
import {deliveryTypes, loadTypes} from "@/repositories/Utils";
import moment from "moment";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";


export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: 'TRS',
      requestSubType: '',
      faq: [],
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestFiles: [],
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      products: [],
      photoIndex: 0,
      rfqTerms: 0,
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        multiSelect: 0,
        ownVariant: 0
      },
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),
      pollAnswerList: [],

      vendorManagementAvailable: false
    };
  },
  watch: {

    "$route"() {
      this.requestType = this.$route.query.type;
    },
    onlyVerified(newVal) {
      this.$t()
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        // this.$swal({
        //   title: this.$t("generalModal.warningTitle"),
        //   text: this.$t("newAUCRequest.onlyVendorModalText"),
        //   icon: 'warning'
        // })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }

  },
  mounted() {

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    createRequest() {
      let sectors = 13;

      let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

      let extras = {
        "version": "1.0.0",
        "pickupCountry": this.orderExtras.pickUpCountry,
        "pickupCity": this.orderExtras.pickUpCity,
        "pickupAddress": this.orderExtras.pickUpAddress,
        "dropOffCountry": this.orderExtras.dropOffCountry,
        "dropOffCity": this.orderExtras.dropOffCity,
        "dropOffAddress": this.orderExtras.dropOffAddress,
        "offerDeadline": deadlineFormatted,
      };

      this.requestSubType = this.requestType;


      if (this.requestTitle !== '' && (sectors + "").length > 0) {

        createRequest(
            this.token,
            this.requestType, this.requestSubType,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras),
            this.products, this.pollAnswerList
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + data.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      } else if (sectors.length < 1) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("generalModal.noWorkingSectorWarning"),
          icon: 'error'
        })
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.butunBolmeleri"),
          icon: 'error'
        })
      }

    },

  }

}
</script>
